
// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate } from 'react-router-dom';
// import "../Register Styles/bootstrap.min.css";
// import "../Register Styles/cursor.min.css";
// import "../Register Styles/animate.min.css";
// import "../Register Styles/aos.min.css";
// import "../Register Styles/swiper-bundle.min.css";
// import "../Register Styles/magnific-popup.min.css";
// import "../Register Styles/odometer.min.css";
// import "../Register Styles/custom.min.css";
// import "../Register Styles/style.css";

// // Import images
// import logo from "../assets/images/site_logo/logo.webp";
// import googleIcon from "../assets/icons/icon_google.svg";
// import dividerShape from "../assets/images/shapes/shape_divider.svg";
// import flowerShape from "../assets/images/shapes/shape_flower_1.svg";
// import footerShape from "../assets/images/shapes/shape_ico_hero_section_bottom.svg";
// import { setUserData } from "../Redux/user_information";
// import { useDispatch } from "react-redux";

// // Password visibility icons
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// const SignIn = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formData, setFormData] = useState({
//     login_id: "",
//     password: ""
//   });
//   const [error, setError] = useState("");
//   const [rememberMe, setRememberMe] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const recaptchaRef = useRef(null);

//   useEffect(() => {
//     // Check for saved login credentials
//     const savedLoginId = localStorage.getItem('rememberedLoginId');
//     const savedPassword = localStorage.getItem('rememberedPassword');
    
//     if (savedLoginId && savedPassword) {
//       setFormData({
//         login_id: savedLoginId,
//         password: savedPassword
//       });
//       setRememberMe(true);
//     }

//     // Load reCAPTCHA script
//     const loadRecaptcha = () => {
//       if (document.querySelector('script[src*="recaptcha"]')) {
//         return;
//       }

//       const script = document.createElement('script');
//       script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
//       script.async = true;
//       script.defer = true;
//       document.body.appendChild(script);
//     };

//     loadRecaptcha();

//     return () => {
//       if (window.grecaptcha && recaptchaRef.current) {
//         const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//         if (widgetId) {
//           try {
//             window.grecaptcha.reset(widgetId);
//           } catch (error) {
//             console.error('Error resetting recaptcha:', error);
//           }
//         }
//       }
//     };
//   }, []);

//   const initializeRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       try {
//         const existingWidgetId = recaptchaRef.current.getAttribute('data-widget-id');
//         if (existingWidgetId) {
//           return;
//         }

//         const widgetId = window.grecaptcha.render(recaptchaRef.current, {
//           sitekey: '6Ld08hwsAAAAANC-Zywq87embbXedv98UPR_2D62',
//           size: 'invisible',
//           callback: (token) => {
//             handleSignIn(token);
//           },
//           'error-callback': () => {
//             console.error('reCAPTCHA failed to load');
//             setIsSubmitting(false);
//             setError('reCAPTCHA verification failed. Please try again.');
//           }
//         });
//         recaptchaRef.current.setAttribute('data-widget-id', widgetId);
//       } catch (error) {
//         console.error('Error initializing recaptcha:', error);
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//     // Clear error when user starts typing
//     if (error) setError("");
//   };

//   const executeRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//       if (widgetId) {
//         try {
//           window.grecaptcha.execute(parseInt(widgetId));
//         } catch (error) {
//           console.error('Error executing recaptcha:', error);
//           setIsSubmitting(false);
//           setError('reCAPTCHA verification failed. Please try again.');
//         }
//       } else {
//         initializeRecaptcha();
//         setTimeout(() => {
//           const newWidgetId = recaptchaRef.current?.getAttribute('data-widget-id');
//           if (newWidgetId) {
//             window.grecaptcha.execute(parseInt(newWidgetId));
//           } else {
//             setIsSubmitting(false);
//             setError('reCAPTCHA initialization failed. Please refresh the page.');
//           }
//         }, 500);
//       }
//     } else {
//       // Fallback if reCAPTCHA is not loaded
//       handleSignIn();
//     }
//   };

//   const handleSignIn = async (recaptchaToken = null) => {
//     try {
//       // Prepare login data according to API documentation
//       const loginData = {
//         login_id: formData.login_id,
//         password: formData.password
//       };

//       // Add reCAPTCHA token if available
//       if (recaptchaToken) {
//         loginData.recaptcha_token = recaptchaToken;
//       }

//       console.log('Sending login data:', loginData);

//       // API call to login endpoint
//       const response = await fetch('https://admin.oceaniabloom9.com/api/login', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(loginData)
//       });

//       const result = await response.json();

//       if (response.ok && result.status === true) {
//         // Login successful
//         console.log('Login successful:', result);

//         // Store user data using Redux dispatch
//         const userData = result.data;
//         const token = result.token;
        
//         // Dispatch to Redux store with all wallet information
//         dispatch(setUserData({
//           userData: {
//             ...userData,
//             // Store all wallets from the response
//             wallets: {
//               main_wallet: userData.main_wallet || 0,
//               release_wallet: userData.release_wallet || 0,
//               current_wallet: userData.current_wallet || 0
//             }
//           },
//           token,
//           rememberMe
//         }));

//         // Store credentials if "Remember Me" is checked
//         if (rememberMe) {
//           localStorage.setItem('rememberedLoginId', formData.login_id);
//           localStorage.setItem('rememberedPassword', formData.password);
//         } else {
//           // Clear saved credentials
//           localStorage.removeItem('rememberedLoginId');
//           localStorage.removeItem('rememberedPassword');
//         }

//         // Store session timestamp (optional, for session management)
//         localStorage.setItem('loginTime', new Date().toISOString());

//         navigate('/dashboard');
//       } else {
//         // Login failed
//         const errorMessage = result.message || 'Login failed. Please check your credentials.';
//         setError(errorMessage);
//         alert(errorMessage);
//       }

//     } catch (error) {
//       console.error('Login error:', error);
//       setError('An error occurred during login. Please try again.');
//       alert('An error occurred during login. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//       resetRecaptcha();
//     }
//   };

//   const resetRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//       if (widgetId) {
//         try {
//           window.grecaptcha.reset(parseInt(widgetId));
//         } catch (error) {
//           console.error('Error resetting recaptcha:', error);
//         }
//       }
//     }
//   };

//   const validateLoginForm = () => {
//     if (!formData.login_id.trim()) {
//       setError('Please enter your login ID');
//       return false;
//     }

//     if (!formData.password) {
//       setError('Please enter your password');
//       return false;
//     }

//     // Clear any previous errors
//     setError("");
//     return true;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (isSubmitting) return;

//     if (!validateLoginForm()) return;

//     setIsSubmitting(true);
//     executeRecaptcha();
//   };

//   const handleForgotPassword = () => {
//     navigate('/forgot-password');
//   };

//   const handleGoogleLogin = (e) => {
//     e.preventDefault();
//     alert('Google login feature coming soon!');
//   };

//   const handleResetPassword = () => {
//     // This would be triggered after first login with system-generated password
//     navigate('/reset-password');
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className="page_wrapper index_ico">
//       {/* Back To Top - Start */}
//       <div className="backtotop">
//         <a href="#" className="scroll">
//           <i className="fa-solid fa-arrow-up"></i>
//         </a>
//       </div>
//       {/* Back To Top - End */}

//       {/* Site Header - Start */}
//       <header className="site_header">
//         <div className="nav_wrapper">
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-lg-3 col-5 d-flex align-items-center">
//                 <div className="site_logo">
//                   <a className="site_link" href="/">
//                     <img loading="lazy" src={logo} alt="Logo" />
//                   </a>
//                 </div>
//               </div>
//               <div className="col-lg-6 col-2">
//               <nav className="main_menu navbar-box navbar-expand-lg">
//                   <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
//                     <ul className="main_menu_list unordered_list text-uppercase">
//                       <li className="active">
//                         <a className="nav-link" href="/">
//                           <span className="nav_link_label" data-text="Home">Home</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#about">
//                           <span className="nav_link_label" data-text="About Us">About Us</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#services">
//                           <span className="nav_link_label" data-text="Services">Services</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#metamask">
//                           <span className="nav_link_label" data-text="Metamask">Metamask</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link" href="#contact">
//                           <span className="nav_link_label" data-text="Contact Us">Contact Us</span>
//                         </a>
//                       </li>
//                     </ul>
//                   </div>
//                 </nav>
//               </div>
//               <div className="col-lg-3 col-5">
//                 <ul className="btns_group unordered_list p-0 justify-content-end">
//                   <li className="d-lg-none">
//                     <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
//                       <i className="far fa-bars"></i>
//                     </button>
//                   </li>
//                   <li>
//                     <a className="ico_btn_outline" href="/register">
//                       <span className="btn_icon">
//                         <i className="fa-solid fa-user-plus"></i>
//                       </span>
//                       <span className="btn_label">Register</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//       {/* Site Header - End */}

//       <main className="page_content">
//         <section className="register_section section_decoration">
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-lg-5 position-relative">
//                 <form className="register_form" onSubmit={handleSubmit}>
//                   <h1 className="heading_text text-center">Login to Willow Quantum</h1>
//                   <p className="text-center">Enter your details to access your account</p>

//                   {/* Login ID Input Field */}
//                   <div className="form-group">
//                     <label className="input_title" htmlFor="input_login_id">
//                       Login ID<sup>*</sup>
//                     </label>
//                     <input
//                       id="input_login_id"
//                       className={`form-control ${error ? 'is-invalid' : ''}`}
//                       type="text"
//                       name="login_id"
//                       value={formData.login_id}
//                       onChange={handleInputChange}
//                       placeholder="Enter your email or account name"
//                       required
//                       disabled={isSubmitting}
//                       autocomplete="off"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label className="input_title" htmlFor="input_password">
//                       Password<sup>*</sup>
//                     </label>
//                     <div className="password-input-group" style={{ position: 'relative' }}>
//                       <input
//                         id="input_password"
//                         className={`form-control ${error ? 'is-invalid' : ''}`}
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         placeholder="Enter your password"
//                         required
//                         disabled={isSubmitting}
//                         style={{ paddingRight: '45px' }}
//                         autocomplete="off"
//                       />
//                       <button
//                         type="button"
//                         className="password-toggle-btn"
//                         onClick={togglePasswordVisibility}
//                         disabled={isSubmitting}
//                         style={{
//                           position: 'absolute',
//                           right: '10px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           color: '#6c757d',
//                           cursor: 'pointer',
//                           padding: '5px',
//                           zIndex: 2
//                         }}
//                       >
//                         <FontAwesomeIcon 
//                           icon={showPassword ? faEyeSlash : faEye} 
//                           style={{ fontSize: '18px' }}
//                         />
//                       </button>
//                     </div>
//                     {error && (
//                       <div className="invalid-feedback d-block">{error}</div>
//                     )}
//                   </div>

//                   {/* Remember Me and Forgot Password */}
//                   <div className="form-group">
//                     <div className="row align-items-center">
//                       <div className="col-md-6">
//                         <div className="form-check">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="rememberMe"
//                             checked={rememberMe}
//                             onChange={(e) => setRememberMe(e.target.checked)}
//                             disabled={isSubmitting}
//                           />
//                           <label className="form-check-label" htmlFor="rememberMe">
//                             Remember me
//                           </label>
//                         </div>
//                       </div>
//                       <div className="col-md-6 text-end">
//                         <button
//                           type="button"
//                           className="btn btn-link p-0"
//                           onClick={handleForgotPassword}
//                           disabled={isSubmitting}
//                           style={{ fontSize: '14px' }}
//                         >
//                           Forgot password?
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Invisible reCAPTCHA */}
//                   <div ref={recaptchaRef} style={{ display: 'none' }} />

//                   <div className="row">
//                     <div className="col-md-12 text-center">
//                       <p className="forget_pass mb-0">
//                         New user? <a href="/register"><u>Register here</u></a>
//                       </p>
//                     </div>
//                   </div>

//                   <button
//                     className="btn"
//                     type="submit"
//                     disabled={isSubmitting}
//                     style={{ position: 'relative' }}
//                   >
//                     <span className="btn_label">
//                       {isSubmitting ? 'Quantum...' : 'Login'}
//                     </span>
//                     <span className="btn_icon">
//                       {isSubmitting ? (
//                         <div className="spinner-border spinner-border-sm" role="status">
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                       ) : (
//                         <i className="fa-regular fa-arrow-up-right"></i>
//                       )}
//                     </span>
//                   </button>
//                 </form>

//                 <div className="decoration_item shape_flower">
//                   <img src={flowerShape} alt="Flower" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* Site Footer - Start */}
//       <footer className="ico_site_footer section_decoration section_shadow_top">
//         <div className="decoration_item shape_top">
//           <img src={footerShape} alt="Bottom Line Shape" />
//         </div>
//         <div className="container">
//           <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
//             <li>
//               <a className="scrollspy_btn" href="#home">
//                 <span className="pagelist_label">Home</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#about">
//                 <span className="pagelist_label">About Us</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#services">
//                 <span className="pagelist_label">Services</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#metamask">
//                 <span className="pagelist_label">Metamask</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#team">
//                 <span className="pagelist_label">Team</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#contact">
//                 <span className="pagelist_label">Contact Us</span>
//               </a>
//             </li>
//           </ul>
//           <div className="middle_area">
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Join our social group</h3>
//               <ul className="social_block style_2 unordered_list justify-content-center">
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M12.1817 2.34636C10.5036 3.04236 7.14877 4.48456 2.11879 6.67146C1.30201 6.99576 0.873436 7.31296 0.834656 7.62286C0.768491 8.14806 1.42705 8.35476 2.32148 8.63456C2.44372 8.67336 2.57025 8.71206 2.69969 8.75516C3.58123 9.04066 4.76611 9.37506 5.38149 9.38796C5.9409 9.39946 6.56497 9.16986 7.25381 8.69916C11.9531 5.53206 14.379 3.93206 14.5314 3.89756C14.6393 3.87316 14.7888 3.84166 14.8894 3.93206C14.9901 4.02106 14.9801 4.19036 14.97 4.23626C14.9038 4.51326 12.3241 6.90826 10.9868 8.14806C10.5698 8.53416 10.2749 8.80826 10.2146 8.87136C10.0794 9.01056 9.94141 9.14396 9.80908 9.27176C8.98941 10.0581 8.37683 10.6494 9.84356 11.6137C10.5482 12.0772 11.1119 12.4604 11.6741 12.8421C12.2882 13.2597 12.9008 13.6758 13.6945 14.1953C13.8959 14.3273 14.0886 14.4636 14.2769 14.5971C14.9916 15.1065 15.6343 15.5628 16.4281 15.4911C16.8883 15.448 17.3656 15.0161 17.6072 13.726C18.1781 10.6752 19.3026 4.06836 19.5629 1.34476C19.5788 1.11856 19.5691 0.891358 19.5341 0.667358C19.5132 0.486458 19.425 0.320058 19.2868 0.201058C19.0812 0.0331581 18.7619 -0.002742 18.6182 0.000158001C17.9696 0.011558 16.9746 0.357458 12.1817 2.34636Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M14.7876 14L9.31558 5.8405L9.32498 5.8482L14.2588 0H12.6101L8.59076 4.76L5.39902 0H1.07488L6.18362 7.6179L0.794922 14H2.44366L6.91214 8.7042L10.4635 14H14.7876ZM4.74576 1.2727L12.4234 12.7273H11.1168L3.43295 1.2727H4.74576Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <i className="fa-brands fa-github" />
//                   </a>
//                 </li>
//               </ul>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Subscribe to our newsletter</h3>
//               <form className="ico_newsletter_form" action="#">
//                 <input type="email" name="email" placeholder="Enter your email" />
//                 <button className="submit_btn" type="submit">Submit</button>
//               </form>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
//               <a className="ico_creative_btn" href="#!">
//                 <span className="btn_wrapper">
//                   <span className="btn_icon_left">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
//                       <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
//                       <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
//                     </svg>
//                   </span>
//                   <span className="btn_label">Purchase a Token</span>
//                   <span className="btn_icon_right">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
//                       <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
//                       <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
//                     </svg>
//                   </span>
//                 </span>
//               </a>
//             </div>
//           </div>
//           <div className="footer_bottom text-center">
//             <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Quantum. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//       {/* Site Footer - End */}
//     </div>
//   );
// };

// export default SignIn;

// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate } from 'react-router-dom';
// import "../Register Styles/bootstrap.min.css";
// import "../Register Styles/cursor.min.css";
// import "../Register Styles/animate.min.css";
// import "../Register Styles/aos.min.css";
// import "../Register Styles/swiper-bundle.min.css";
// import "../Register Styles/magnific-popup.min.css";
// import "../Register Styles/odometer.min.css";
// import "../Register Styles/custom.min.css";
// import "../Register Styles/style.css";
// import { toast } from 'react-toastify'; // Import toast

// // Import images
// import logo from "../assets/images/site_logo/logo.webp";
// import googleIcon from "../assets/icons/icon_google.svg";
// import dividerShape from "../assets/images/shapes/shape_divider.svg";
// import flowerShape from "../assets/images/shapes/shape_flower_1.svg";
// import footerShape from "../assets/images/shapes/shape_ico_hero_section_bottom.svg";
// import { setUserData } from "../Redux/user_information";
// import { useDispatch } from "react-redux";

// // Password visibility icons
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// const SignIn = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formData, setFormData] = useState({
//     login_id: "",
//     password: ""
//   });
//   const [error, setError] = useState("");
//   const [rememberMe, setRememberMe] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const recaptchaRef = useRef(null);

//   useEffect(() => {
//     // Check for saved login credentials
//     const savedLoginId = localStorage.getItem('rememberedLoginId');
//     const savedPassword = localStorage.getItem('rememberedPassword');
    
//     if (savedLoginId && savedPassword) {
//       setFormData({
//         login_id: savedLoginId,
//         password: savedPassword
//       });
//       setRememberMe(true);
//     }

//     // Load reCAPTCHA script
//     const loadRecaptcha = () => {
//       if (document.querySelector('script[src*="recaptcha"]')) {
//         return;
//       }

//       const script = document.createElement('script');
//       script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
//       script.async = true;
//       script.defer = true;
//       document.body.appendChild(script);
//     };

//     loadRecaptcha();

//     return () => {
//       if (window.grecaptcha && recaptchaRef.current) {
//         const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//         if (widgetId) {
//           try {
//             window.grecaptcha.reset(widgetId);
//           } catch (error) {
//             console.error('Error resetting recaptcha:', error);
//           }
//         }
//       }
//     };
//   }, []);

//   const initializeRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       try {
//         const existingWidgetId = recaptchaRef.current.getAttribute('data-widget-id');
//         if (existingWidgetId) {
//           return;
//         }

//         const widgetId = window.grecaptcha.render(recaptchaRef.current, {
//           sitekey: '6Ld08hwsAAAAANC-Zywq87embbXedv98UPR_2D62',
//           size: 'invisible',
//           callback: (token) => {
//             handleSignIn(token);
//           },
//           'error-callback': () => {
//             console.error('reCAPTCHA failed to load');
//             setIsSubmitting(false);
//             setError('reCAPTCHA verification failed. Please try again.');
//             toast.error('reCAPTCHA verification failed. Please try again.');
//           }
//         });
//         recaptchaRef.current.setAttribute('data-widget-id', widgetId);
//       } catch (error) {
//         console.error('Error initializing recaptcha:', error);
//         toast.error('Error initializing security verification. Please try again.');
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//     // Clear error when user starts typing
//     if (error) setError("");
//   };

//   const executeRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//       if (widgetId) {
//         try {
//           window.grecaptcha.execute(parseInt(widgetId));
//         } catch (error) {
//           console.error('Error executing recaptcha:', error);
//           setIsSubmitting(false);
//           setError('reCAPTCHA verification failed. Please try again.');
//           toast.error('reCAPTCHA verification failed. Please try again.');
//         }
//       } else {
//         initializeRecaptcha();
//         setTimeout(() => {
//           const newWidgetId = recaptchaRef.current?.getAttribute('data-widget-id');
//           if (newWidgetId) {
//             window.grecaptcha.execute(parseInt(newWidgetId));
//           } else {
//             setIsSubmitting(false);
//             setError('reCAPTCHA initialization failed. Please refresh the page.');
//             toast.error('reCAPTCHA initialization failed. Please refresh the page.');
//           }
//         }, 500);
//       }
//     } else {
//       // Fallback if reCAPTCHA is not loaded
//       handleSignIn();
//     }
//   };

//   const handleSignIn = async (recaptchaToken = null) => {
//     try {
//       // Prepare login data according to API documentation
//       const loginData = {
//         login_id: formData.login_id,
//         password: formData.password
//       };

//       // Add reCAPTCHA token if available
//       if (recaptchaToken) {
//         loginData.recaptcha_token = recaptchaToken;
//       }

//       console.log('Sending login data:', loginData);

//       // API call to login endpoint
//       const response = await fetch('https://admin.oceaniabloom9.com/api/login', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(loginData)
//       });

//       const result = await response.json();

//       if (response.ok && result.status === true) {
//         // Login successful
//         console.log('Login successful:', result);
//         toast.success(result.message);

//         // Store user data using Redux dispatch
//         const userData = result.data;
//         const token = result.token;
        
//         // Dispatch to Redux store with all wallet information
//         dispatch(setUserData({
//           userData: {
//             ...userData,
//             // Store all wallets from the response
//             wallets: {
//               main_wallet: userData.main_wallet || 0,
//               release_wallet: userData.release_wallet || 0,
//               current_wallet: userData.current_wallet || 0
//             }
//           },
//           token,
//           rememberMe
//         }));

//         // Store credentials if "Remember Me" is checked
//         if (rememberMe) {
//           localStorage.setItem('rememberedLoginId', formData.login_id);
//           localStorage.setItem('rememberedPassword', formData.password);
//         } else {
//           // Clear saved credentials
//           localStorage.removeItem('rememberedLoginId');
//           localStorage.removeItem('rememberedPassword');
//         }

//         // Store session timestamp (optional, for session management)
//         localStorage.setItem('loginTime', new Date().toISOString());

//         navigate('/dashboard');
//       } else {
//         // Login failed
//         const errorMessage = result.message || 'Login failed. Please check your credentials.';
//         setError(errorMessage);
//         toast.error(errorMessage);
//       }

//     } catch (error) {
//       console.error('Login error:', error);
//       setError('An error occurred during login. Please try again.');
//       toast.error('An error occurred during login. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//       resetRecaptcha();
//     }
//   };

//   const resetRecaptcha = () => {
//     if (window.grecaptcha && recaptchaRef.current) {
//       const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//       if (widgetId) {
//         try {
//           window.grecaptcha.reset(parseInt(widgetId));
//         } catch (error) {
//           console.error('Error resetting recaptcha:', error);
//         }
//       }
//     }
//   };

//   const validateLoginForm = () => {
//     if (!formData.login_id.trim()) {
//       setError('Please enter your login ID');
//       toast.error('Please enter your login ID');
//       return false;
//     }

//     if (!formData.password) {
//       setError('Please enter your password');
//       toast.error('Please enter your password');
//       return false;
//     }

//     // Clear any previous errors
//     setError("");
//     return true;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (isSubmitting) return;

//     if (!validateLoginForm()) return;

//     setIsSubmitting(true);
//     executeRecaptcha();
//   };

//   const handleForgotPassword = () => {
//     navigate('/forgot-password');
//   };

//   const handleGoogleLogin = (e) => {
//     e.preventDefault();
//     toast.info('Google login feature coming soon!');
//   };

//   const handleResetPassword = () => {
//     // This would be triggered after first login with system-generated password
//     navigate('/reset-password');
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className="page_wrapper index_ico">
//       {/* Back To Top - Start */}
//       <div className="backtotop">
//         <a href="#" className="scroll">
//           <i className="fa-solid fa-arrow-up"></i>
//         </a>
//       </div>
//       {/* Back To Top - End */}

//       {/* Site Header - Start */}
//       <header className="site_header">
//         <div className="nav_wrapper">
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-lg-3 col-5 d-flex align-items-center">
//                 <div className="site_logo">
//                   <a className="site_link" href="/">
//                     <img loading="lazy" src={logo} alt="Logo" />
//                   </a>
//                 </div>
//               </div>
//               <div className="col-lg-6 col-2">
//               <nav className="main_menu navbar-box navbar-expand-lg">
//                   <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
//                     <ul className="main_menu_list unordered_list text-uppercase">
//                       <li className="active">
//                         <a className="nav-link" href="/">
//                           <span className="nav_link_label" data-text="Home">Home</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#about">
//                           <span className="nav_link_label" data-text="About Us">About Us</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#services">
//                           <span className="nav_link_label" data-text="Services">Services</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#metamask">
//                           <span className="nav_link_label" data-text="Metamask">Metamask</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link" href="#contact">
//                           <span className="nav_link_label" data-text="Contact Us">Contact Us</span>
//                         </a>
//                       </li>
//                     </ul>
//                   </div>
//                 </nav>
//               </div>
//               <div className="col-lg-3 col-5">
//                 <ul className="btns_group unordered_list p-0 justify-content-end">
//                   <li className="d-lg-none">
//                     <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
//                       <i className="far fa-bars"></i>
//                     </button>
//                   </li>
//                   <li>
//                     <a className="ico_btn_outline" href="/register">
//                       <span className="btn_icon">
//                         <i className="fa-solid fa-user-plus"></i>
//                       </span>
//                       <span className="btn_label">Register</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//       {/* Site Header - End */}

//       <main className="page_content">
//         <section className="register_section section_decoration">
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-lg-5 position-relative">
//                 <form className="register_form" onSubmit={handleSubmit}>
//                   <h1 className="heading_text text-center">Login to Willow Quantum</h1>
//                   <p className="text-center">Enter your details to access your account</p>

//                   {/* Login ID Input Field */}
//                   <div className="form-group">
//                     <label className="input_title" htmlFor="input_login_id">
//                       Login ID<sup>*</sup>
//                     </label>
//                     <input
//                       id="input_login_id"
//                       className={`form-control ${error ? 'is-invalid' : ''}`}
//                       type="text"
//                       name="login_id"
//                       value={formData.login_id}
//                       onChange={handleInputChange}
//                       placeholder="Enter your email or account name"
//                       required
//                       disabled={isSubmitting}
//                       autoComplete="off"
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label className="input_title" htmlFor="input_password">
//                       Password<sup>*</sup>
//                     </label>
//                     <div className="password-input-group" style={{ position: 'relative' }}>
//                       <input
//                         id="input_password"
//                         className={`form-control ${error ? 'is-invalid' : ''}`}
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         placeholder="Enter your password"
//                         required
//                         disabled={isSubmitting}
//                         style={{ paddingRight: '45px' }}
//                         autoComplete="off"
//                       />
//                       <button
//                         type="button"
//                         className="password-toggle-btn"
//                         onClick={togglePasswordVisibility}
//                         disabled={isSubmitting}
//                         style={{
//                           position: 'absolute',
//                           right: '10px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           color: '#6c757d',
//                           cursor: 'pointer',
//                           padding: '5px',
//                           zIndex: 2
//                         }}
//                       >
//                         <FontAwesomeIcon 
//                           icon={showPassword ? faEyeSlash : faEye} 
//                           style={{ fontSize: '18px' }}
//                         />
//                       </button>
//                     </div>
//                     {error && (
//                       <div className="invalid-feedback d-block">{error}</div>
//                     )}
//                   </div>

//                   {/* Remember Me and Forgot Password */}
//                   <div className="form-group">
//                     <div className="row align-items-center">
//                       <div className="col-md-6">
//                         <div className="form-check">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="rememberMe"
//                             checked={rememberMe}
//                             onChange={(e) => setRememberMe(e.target.checked)}
//                             disabled={isSubmitting}
//                             style={{border : "1px solid white"}}
//                           />
//                           <label className="form-check-label" htmlFor="rememberMe">
//                             Remember me
//                           </label>
//                         </div>
//                       </div>
//                       <div className="col-md-6 text-end">
//                         <button
//                           type="button"
//                           className="btn btn-link p-0"
//                           onClick={handleForgotPassword}
//                           disabled={isSubmitting}
//                           style={{ fontSize: '14px' }}
//                         >
//                           Forgot password?
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Invisible reCAPTCHA */}
//                   <div ref={recaptchaRef} style={{ display: 'none' }} />

//                   <div className="row">
//                     <div className="col-md-12 text-center">
//                       <p className="forget_pass mb-0">
//                         New user? <a href="/register"><u>Register here</u></a>
//                       </p>
//                     </div>
//                   </div>

//                   <button
//                     className="btn"
//                     type="submit"
//                     disabled={isSubmitting}
//                     style={{ position: 'relative' }}
//                   >
//                     <span className="btn_label">
//                       {isSubmitting ? 'Quantum...' : 'Login'}
//                     </span>
//                     <span className="btn_icon">
//                       {isSubmitting ? (
//                         <div className="spinner-border spinner-border-sm" role="status">
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                       ) : (
//                         <i className="fa-regular fa-arrow-up-right"></i>
//                       )}
//                     </span>
//                   </button>
//                 </form>

//                 <div className="decoration_item shape_flower">
//                   <img src={flowerShape} alt="Flower" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* Site Footer - Start */}
//       <footer className="ico_site_footer section_decoration section_shadow_top">
//         <div className="decoration_item shape_top">
//           <img src={footerShape} alt="Bottom Line Shape" />
//         </div>
//         <div className="container">
//           <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
//             <li>
//               <a className="scrollspy_btn" href="#home">
//                 <span className="pagelist_label">Home</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#about">
//                 <span className="pagelist_label">About Us</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#services">
//                 <span className="pagelist_label">Services</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#metamask">
//                 <span className="pagelist_label">Metamask</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#team">
//                 <span className="pagelist_label">Team</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#contact">
//                 <span className="pagelist_label">Contact Us</span>
//               </a>
//             </li>
//           </ul>
//           <div className="middle_area">
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Join our social group</h3>
//               <ul className="social_block style_2 unordered_list justify-content-center">
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M12.1817 2.34636C10.5036 3.04236 7.14877 4.48456 2.11879 6.67146C1.30201 6.99576 0.873436 7.31296 0.834656 7.62286C0.768491 8.14806 1.42705 8.35476 2.32148 8.63456C2.44372 8.67336 2.57025 8.71206 2.69969 8.75516C3.58123 9.04066 4.76611 9.37506 5.38149 9.38796C5.9409 9.39946 6.56497 9.16986 7.25381 8.69916C11.9531 5.53206 14.379 3.93206 14.5314 3.89756C14.6393 3.87316 14.7888 3.84166 14.8894 3.93206C14.9901 4.02106 14.9801 4.19036 14.97 4.23626C14.9038 4.51326 12.3241 6.90826 10.9868 8.14806C10.5698 8.53416 10.2749 8.80826 10.2146 8.87136C10.0794 9.01056 9.94141 9.14396 9.80908 9.27176C8.98941 10.0581 8.37683 10.6494 9.84356 11.6137C10.5482 12.0772 11.1119 12.4604 11.6741 12.8421C12.2882 13.2597 12.9008 13.6758 13.6945 14.1953C13.8959 14.3273 14.0886 14.4636 14.2769 14.5971C14.9916 15.1065 15.6343 15.5628 16.4281 15.4911C16.8883 15.448 17.3656 15.0161 17.6072 13.726C18.1781 10.6752 19.3026 4.06836 19.5629 1.34476C19.5788 1.11856 19.5691 0.891358 19.5341 0.667358C19.5132 0.486458 19.425 0.320058 19.2868 0.201058C19.0812 0.0331581 18.7619 -0.002742 18.6182 0.000158001C17.9696 0.011558 16.9746 0.357458 12.1817 2.34636Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M14.7876 14L9.31558 5.8405L9.32498 5.8482L14.2588 0H12.6101L8.59076 4.76L5.39902 0H1.07488L6.18362 7.6179L0.794922 14H2.44366L6.91214 8.7042L10.4635 14H14.7876ZM4.74576 1.2727L12.4234 12.7273H11.1168L3.43295 1.2727H4.74576Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <i className="fa-brands fa-github" />
//                   </a>
//                 </li>
//               </ul>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Subscribe to our newsletter</h3>
//               <form className="ico_newsletter_form" action="#">
//                 <input type="email" name="email" placeholder="Enter your email" />
//                 <button className="submit_btn" type="submit">Submit</button>
//               </form>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
//               <a className="ico_creative_btn" href="#!">
//                 <span className="btn_wrapper">
//                   <span className="btn_icon_left">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
//                       <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
//                       <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
//                     </svg>
//                   </span>
//                   <span className="btn_label">Purchase a Token</span>
//                   <span className="btn_icon_right">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
//                       <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
//                       <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
//                     </svg>
//                   </span>
//                 </span>
//               </a>
//             </div>
//           </div>
//           <div className="footer_bottom text-center">
//             <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Quantum. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//       {/* Site Footer - End */}
//     </div>
//   );
// };

// export default SignIn;
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import "../Register Styles/bootstrap.min.css";
import "../Register Styles/cursor.min.css";
import "../Register Styles/animate.min.css";
import "../Register Styles/aos.min.css";
import "../Register Styles/swiper-bundle.min.css";
import "../Register Styles/magnific-popup.min.css";
import "../Register Styles/odometer.min.css";
import "../Register Styles/custom.min.css";
import "../Register Styles/style.css";
import { toast } from 'react-toastify';

// Import images
import logo from "../assets/images/site_logo/logo.webp";
import dividerShape from "../assets/images/shapes/shape_divider.svg";
import flowerShape from "../assets/images/shapes/shape_flower_1.svg";
import footerShape from "../assets/images/shapes/shape_ico_hero_section_bottom.svg";
import { setUserData } from "../Redux/user_information";
import { useDispatch } from "react-redux";

// Password visibility icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTimes, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    login_id: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const recaptchaRef = useRef(null);
  
  // Forgot Password Modal States
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1); // 1: Email, 2: OTP, 3: New Password
  const [forgotPasswordData, setForgotPasswordData] = useState({
    email: "",
    otp: ["", "", "", "", "", ""],
    newPassword: "",
    confirmPassword: ""
  });
  const [otpRefs, setOtpRefs] = useState([]);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isResendingOtp, setIsResendingOtp] = useState(false);
  const [otpTimer, setOtpTimer] = useState(30);
  
  // New states for API calls
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);

  // Initialize OTP refs
  useEffect(() => {
    setOtpRefs(Array(6).fill().map((_, i) => React.createRef()));
  }, []);

  // OTP Timer Effect
  useEffect(() => {
    let interval;
    if (forgotPasswordStep === 2 && otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [forgotPasswordStep, otpTimer]);

  // Load saved credentials and reCAPTCHA
  useEffect(() => {
    const savedLoginId = localStorage.getItem('rememberedLoginId');
    const savedPassword = localStorage.getItem('rememberedPassword');
    
    if (savedLoginId && savedPassword) {
      setFormData({
        login_id: savedLoginId,
        password: savedPassword
      });
      setRememberMe(true);
    }

    const loadRecaptcha = () => {
      if (document.querySelector('script[src*="recaptcha"]')) {
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    loadRecaptcha();

    return () => {
      if (window.grecaptcha && recaptchaRef.current) {
        const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
        if (widgetId) {
          try {
            window.grecaptcha.reset(widgetId);
          } catch (error) {
            console.error('Error resetting recaptcha:', error);
          }
        }
      }
    };
  }, []);

  // Modal close handler with ESC key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && showForgotPasswordModal) {
        handleCloseForgotPasswordModal();
      }
    };
    
    if (showForgotPasswordModal) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscKey);
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [showForgotPasswordModal]);

  // Initialize reCAPTCHA
  const initializeRecaptcha = () => {
    if (window.grecaptcha && recaptchaRef.current) {
      try {
        const existingWidgetId = recaptchaRef.current.getAttribute('data-widget-id');
        if (existingWidgetId) {
          return;
        }

        const widgetId = window.grecaptcha.render(recaptchaRef.current, {
          sitekey: '6Ld08hwsAAAAANC-Zywq87embbXedv98UPR_2D62',
          size: 'invisible',
          callback: (token) => {
            handleSignIn(token);
          },
          'error-callback': () => {
            console.error('reCAPTCHA failed to load');
            setIsSubmitting(false);
            setError('reCAPTCHA verification failed. Please try again.');
            toast.error('reCAPTCHA verification failed. Please try again.');
          }
        });
        recaptchaRef.current.setAttribute('data-widget-id', widgetId);
      } catch (error) {
        console.error('Error initializing recaptcha:', error);
        toast.error('Error initializing security verification. Please try again.');
      }
    }
  };

  // Forgot Password Modal Handlers
  const handleOpenForgotPasswordModal = () => {
    setShowForgotPasswordModal(true);
    setForgotPasswordStep(1);
    setForgotPasswordData({
      email: "",
      otp: ["", "", "", "", "", ""],
      newPassword: "",
      confirmPassword: ""
    });
    setOtpTimer(30);
  };

  const handleCloseForgotPasswordModal = () => {
    setShowForgotPasswordModal(false);
    setForgotPasswordStep(1);
    setForgotPasswordData({
      email: "",
      otp: ["", "", "", "", "", ""],
      newPassword: "",
      confirmPassword: ""
    });
    setOtpTimer(30);
    setIsSendingOtp(false);
    setIsVerifyingOtp(false);
    setIsResettingPassword(false);
  };

  // Step 1: Send OTP Email
  const handleForgotPasswordEmailSubmit = async (e) => {
    e.preventDefault();
    
    if (!forgotPasswordData.email) {
      toast.error('Please enter your email address');
      return;
    }
    
    if (!/\S+@\S+\.\S+/.test(forgotPasswordData.email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    setIsSendingOtp(true);
    
    try {
      const response = await fetch('https://admin.oceaniabloom9.com/api/send-forgot-password-email-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: forgotPasswordData.email
        })
      });

      const result = await response.json();
      
      if (response.ok && result.status === true) {
        toast.success(result.message || 'OTP sent successfully!');
        setForgotPasswordStep(2);
        setOtpTimer(30);
        
        // Auto-focus first OTP input
        setTimeout(() => {
          if (otpRefs[0] && otpRefs[0].current) {
            otpRefs[0].current.focus();
          }
        }, 100);
      } else {
        const errorMessage = result.message || 'Failed to send OTP. Please try again.';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      toast.error('An error occurred while sending OTP. Please try again.');
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleOtpChange = (index, value) => {
    if (value.length > 1) {
      value = value.charAt(0); // Take only first character
    }
    
    if (!/^\d*$/.test(value)) {
      return; // Only allow numbers
    }
    
    const newOtp = [...forgotPasswordData.otp];
    newOtp[index] = value;
    setForgotPasswordData({ ...forgotPasswordData, otp: newOtp });
    
    // Auto-focus next input
    if (value && index < 5) {
      if (otpRefs[index + 1] && otpRefs[index + 1].current) {
        otpRefs[index + 1].current.focus();
      }
    }
    
    // Auto-submit if all fields are filled
    if (index === 5 && value && newOtp.every(digit => digit !== "")) {
      // Auto verify when all fields filled
      handleOtpSubmit(new Event('submit'));
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !forgotPasswordData.otp[index] && index > 0) {
      // Move to previous input on backspace
      if (otpRefs[index - 1] && otpRefs[index - 1].current) {
        otpRefs[index - 1].current.focus();
      }
    }
  };

  // Step 2: Verify OTP
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    
    const otpValue = forgotPasswordData.otp.join('');
    if (otpValue.length !== 6) {
      toast.error('Please enter all 6 digits of the OTP');
      return;
    }
    
    setIsVerifyingOtp(true);
    
    try {
      const response = await fetch('https://admin.oceaniabloom9.com/api/verify-forgot-password-email-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: forgotPasswordData.email,
          otp: otpValue
        })
      });

      const result = await response.json();
      
      if (response.ok && result.status === true) {
        toast.success(result.message || 'OTP verified successfully!');
        setForgotPasswordStep(3);
      } else {
        const errorMessage = result.message || 'Invalid OTP. Please try again.';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      toast.error('An error occurred while verifying OTP. Please try again.');
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  // Step 3: Reset Password
  const handleNewPasswordSubmit = async (e) => {
    e.preventDefault();
    
    if (!forgotPasswordData.newPassword) {
      toast.error('Please enter new password');
      return;
    }
    
    if (forgotPasswordData.newPassword.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }
    
    if (forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    
    setIsResettingPassword(true);
    
    try {
      const response = await fetch('https://admin.oceaniabloom9.com/api/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: forgotPasswordData.email,
          password: forgotPasswordData.newPassword,
          confirm_password: forgotPasswordData.confirmPassword
        })
      });

      const result = await response.json();
      
      if (response.ok && result.status === true) {
        toast.success(result.message || 'Password reset successfully!');
        
        // Close modal after delay
        setTimeout(() => {
          handleCloseForgotPasswordModal();
          toast.info('Please login with your new password');
        }, 1500);
      } else {
        const errorMessage = result.message || 'Failed to reset password. Please try again.';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      toast.error('An error occurred while resetting password. Please try again.');
    } finally {
      setIsResettingPassword(false);
    }
  };

  const handleResendOtp = async () => {
    if (isResendingOtp || otpTimer > 0) return;
    
    setIsResendingOtp(true);
    
    try {
      const response = await fetch('https://admin.oceaniabloom9.com/api/send-forgot-password-email-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: forgotPasswordData.email
        })
      });

      const result = await response.json();
      
      if (response.ok && result.status === true) {
        setIsResendingOtp(false);
        setOtpTimer(30);
        toast.success(result.message || 'New OTP sent to your email');
      } else {
        const errorMessage = result.message || 'Failed to resend OTP. Please try again.';
        toast.error(errorMessage);
        setIsResendingOtp(false);
      }
    } catch (error) {
      console.error('Error resending OTP:', error);
      toast.error('An error occurred while resending OTP. Please try again.');
      setIsResendingOtp(false);
    }
  };

  const handleBackStep = () => {
    if (forgotPasswordStep > 1) {
      setForgotPasswordStep(forgotPasswordStep - 1);
    }
  };

  // Rest of your existing functions (handleInputChange, executeRecaptcha, handleSignIn, etc.)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (error) setError("");
  };

  const executeRecaptcha = () => {
    if (window.grecaptcha && recaptchaRef.current) {
      const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
      if (widgetId) {
        try {
          window.grecaptcha.execute(parseInt(widgetId));
        } catch (error) {
          console.error('Error executing recaptcha:', error);
          setIsSubmitting(false);
          setError('reCAPTCHA verification failed. Please try again.');
          toast.error('reCAPTCHA verification failed. Please try again.');
        }
      } else {
        initializeRecaptcha();
        setTimeout(() => {
          const newWidgetId = recaptchaRef.current?.getAttribute('data-widget-id');
          if (newWidgetId) {
            window.grecaptcha.execute(parseInt(newWidgetId));
          } else {
            setIsSubmitting(false);
            setError('reCAPTCHA initialization failed. Please refresh the page.');
            toast.error('reCAPTCHA initialization failed. Please refresh the page.');
          }
        }, 500);
      }
    } else {
      handleSignIn();
    }
  };

  const handleSignIn = async (recaptchaToken = null) => {
    try {
      const loginData = {
        login_id: formData.login_id,
        password: formData.password
      };

      if (recaptchaToken) {
        loginData.recaptcha_token = recaptchaToken;
      }

      console.log('Sending login data:', loginData);

      const response = await fetch('https://admin.oceaniabloom9.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData)
      });

      const result = await response.json();

      if (response.ok && result.status === true) {
        console.log('Login successful:', result);
        toast.success(result.message);

        const userData = result.data;
        const token = result.token;
        
        dispatch(setUserData({
          userData: {
            ...userData,
            wallets: {
              main_wallet: userData.main_wallet || 0,
              release_wallet: userData.release_wallet || 0,
              current_wallet: userData.current_wallet || 0
            }
          },
          token,
          rememberMe
        }));

        if (rememberMe) {
          localStorage.setItem('rememberedLoginId', formData.login_id);
          localStorage.setItem('rememberedPassword', formData.password);
        } else {
          localStorage.removeItem('rememberedLoginId');
          localStorage.removeItem('rememberedPassword');
        }

        localStorage.setItem('loginTime', new Date().toISOString());

        navigate('/dashboard');
      } else {
        const errorMessage = result.message || 'Login failed. Please check your credentials.';
        setError(errorMessage);
        toast.error(errorMessage);
      }

    } catch (error) {
      console.error('Login error:', error);
      setError('An error occurred during login. Please try again.');
      toast.error('An error occurred during login. Please try again.');
    } finally {
      setIsSubmitting(false);
      resetRecaptcha();
    }
  };

  const resetRecaptcha = () => {
    if (window.grecaptcha && recaptchaRef.current) {
      const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
      if (widgetId) {
        try {
          window.grecaptcha.reset(parseInt(widgetId));
        } catch (error) {
          console.error('Error resetting recaptcha:', error);
        }
      }
    }
  };

  const validateLoginForm = () => {
    if (!formData.login_id.trim()) {
      setError('Please enter your login ID');
      toast.error('Please enter your login ID');
      return false;
    }

    if (!formData.password) {
      setError('Please enter your password');
      toast.error('Please enter your password');
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validateLoginForm()) return;

    setIsSubmitting(true);
    executeRecaptcha();
  };

  const handleGoogleLogin = (e) => {
    e.preventDefault();
    toast.info('Google login feature coming soon!');
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="page_wrapper index_ico">
      {/* Forgot Password Modal */}
      {showForgotPasswordModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)'
        }}>
          <div className="modal-content" style={{
            backgroundColor: '#1a1a2e',
            borderRadius: '16px',
            padding: '40px',
            width: '90%',
            maxWidth: '450px',
            position: 'relative',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            animation: 'fadeIn 0.3s ease'
          }}>
            <style>
              {`
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(-20px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}
            </style>
            
            {/* Close Button */}
            <button
              onClick={handleCloseForgotPasswordModal}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: '24px',
                cursor: 'pointer',
                opacity: 0.7,
                transition: 'opacity 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            {/* Step Indicator */}
            <div style={{ marginBottom: '30px' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '20px'
              }}>
                {[1, 2, 3].map((step) => (
                  <React.Fragment key={step}>
                    <div style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: forgotPasswordStep >= step ? '#4f46e5' : 'rgba(255, 255, 255, 0.1)',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      transition: 'all 0.3s'
                    }}>
                      {step}
                    </div>
                    {step < 3 && (
                      <div style={{
                        width: '40px',
                        height: '2px',
                        backgroundColor: forgotPasswordStep > step ? '#4f46e5' : 'rgba(255, 255, 255, 0.1)'
                      }} />
                    )}
                  </React.Fragment>
                ))}
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '12px',
                color: 'rgba(255, 255, 255, 0.7)',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                <span>Email</span>
                <span>Verify OTP</span>
                <span>New Password</span>
              </div>
            </div>

            {/* Back Button (for steps 2 & 3) */}
            {forgotPasswordStep > 1 && (
              <button
                onClick={handleBackStep}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#4f46e5',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '20px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  transition: 'opacity 0.3s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Back
              </button>
            )}

            {/* Step 1: Email Input */}
            {forgotPasswordStep === 1 && (
              <form onSubmit={handleForgotPasswordEmailSubmit}>
                <h2 style={{
                  color: '#fff',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  textAlign: 'center'
                }}>
                  Forgot Password
                </h2>
                <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center',
                  marginBottom: '30px',
                  fontSize: '14px'
                }}>
                  Enter your email address to receive a verification code
                </p>
                
                <div style={{ marginBottom: '25px' }}>
                  <label style={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.9)',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}>
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={forgotPasswordData.email}
                    onChange={(e) => setForgotPasswordData({
                      ...forgotPasswordData,
                      email: e.target.value
                    })}
                    placeholder="Enter your email"
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      backgroundColor: 'rgba(255, 255, 255, 0.05)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '14px',
                      transition: 'all 0.3s'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                    onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                    autoFocus
                    disabled={isSendingOtp}
                  />
                </div>
                
                <button
                  type="submit"
                  disabled={isSendingOtp}
                  style={{
                    width: '100%',
                    padding: '16px',
                    backgroundColor: isSendingOtp ? 'rgba(79, 70, 229, 0.7)' : '#4f46e5',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: isSendingOtp ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    position: 'relative'
                  }}
                  onMouseEnter={(e) => {
                    if (!isSendingOtp) {
                      e.currentTarget.style.backgroundColor = '#4338ca';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSendingOtp) {
                      e.currentTarget.style.backgroundColor = '#4f46e5';
                    }
                  }}
                >
                  {isSendingOtp ? (
                    <>
                      <span>Sending...</span>
                      <div style={{
                        display: 'inline-block',
                        marginLeft: '10px',
                        width: '16px',
                        height: '16px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        verticalAlign: 'middle'
                      }} />
                    </>
                  ) : 'Send Verification Code'}
                </button>
              </form>
            )}

            {/* Step 2: OTP Verification */}
            {forgotPasswordStep === 2 && (
              <form onSubmit={handleOtpSubmit}>
                <h2 style={{
                  color: '#fff',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  textAlign: 'center'
                }}>
                  Verify OTP
                </h2>
                <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center',
                  marginBottom: '5px',
                  fontSize: '14px'
                }}>
                  Enter the 6-digit code sent to
                </p>
                <p style={{
                  color: '#4f46e5',
                  textAlign: 'center',
                  marginBottom: '30px',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  {forgotPasswordData.email}
                </p>
                
                <div style={{ marginBottom: '25px' }}>
                  <label style={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.9)',
                    marginBottom: '15px',
                    fontSize: '14px',
                    fontWeight: '500',
                    textAlign: 'center'
                  }}>
                    6-Digit Verification Code
                  </label>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                  }}>
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                      <input
                        key={index}
                        ref={otpRefs[index]}
                        type="text"
                        maxLength="1"
                        value={forgotPasswordData.otp[index]}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        style={{
                          width: '50px',
                          height: '60px',
                          textAlign: 'center',
                          fontSize: '24px',
                          fontWeight: 'bold',
                          backgroundColor: 'rgba(255, 255, 255, 0.05)',
                          border: `1px solid ${forgotPasswordData.otp[index] ? '#4f46e5' : 'rgba(255, 255, 255, 0.1)'}`,
                          borderRadius: '8px',
                          color: '#fff',
                          transition: 'all 0.3s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                        onBlur={(e) => {
                          if (!forgotPasswordData.otp[index]) {
                            e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                          }
                        }}
                        disabled={isVerifyingOtp}
                      />
                    ))}
                  </div>
                  
                  {/* OTP Timer/Resend */}
                  <div style={{
                    textAlign: 'center',
                    marginTop: '15px'
                  }}>
                    {otpTimer > 0 ? (
                      <p style={{
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: '13px'
                      }}>
                        Resend OTP in {otpTimer}s
                      </p>
                    ) : (
                      <button
                        type="button"
                        onClick={handleResendOtp}
                        disabled={isResendingOtp}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: isResendingOtp ? 'rgba(79, 70, 229, 0.7)' : '#4f46e5',
                          fontSize: '13px',
                          cursor: isResendingOtp ? 'not-allowed' : 'pointer',
                          textDecoration: 'underline',
                          transition: 'opacity 0.3s'
                        }}
                        onMouseEnter={(e) => {
                          if (!isResendingOtp) {
                            e.currentTarget.style.opacity = '0.8';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isResendingOtp) {
                            e.currentTarget.style.opacity = '1';
                          }
                        }}
                      >
                        {isResendingOtp ? 'Resending...' : 'Resend OTP'}
                      </button>
                    )}
                  </div>
                </div>
                
                <button
                  type="submit"
                  disabled={isVerifyingOtp || forgotPasswordData.otp.some(digit => digit === "")}
                  style={{
                    width: '100%',
                    padding: '16px',
                    backgroundColor: (isVerifyingOtp || forgotPasswordData.otp.some(digit => digit === "")) 
                      ? 'rgba(79, 70, 229, 0.5)' : '#4f46e5',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: (isVerifyingOtp || forgotPasswordData.otp.some(digit => digit === "")) 
                      ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    position: 'relative'
                  }}
                  onMouseEnter={(e) => {
                    if (!isVerifyingOtp && !forgotPasswordData.otp.some(digit => digit === "")) {
                      e.currentTarget.style.backgroundColor = '#4338ca';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isVerifyingOtp && !forgotPasswordData.otp.some(digit => digit === "")) {
                      e.currentTarget.style.backgroundColor = '#4f46e5';
                    }
                  }}
                >
                  {isVerifyingOtp ? (
                    <>
                      <span>Verifying...</span>
                      <div style={{
                        display: 'inline-block',
                        marginLeft: '10px',
                        width: '16px',
                        height: '16px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        verticalAlign: 'middle'
                      }} />
                    </>
                  ) : 'Verify & Continue'}
                </button>
              </form>
            )}

            {/* Step 3: New Password */}
            {forgotPasswordStep === 3 && (
              <form onSubmit={handleNewPasswordSubmit}>
                <h2 style={{
                  color: '#fff',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  textAlign: 'center'
                }}>
                  Create New Password
                </h2>
                <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  textAlign: 'center',
                  marginBottom: '30px',
                  fontSize: '14px'
                }}>
                  Create a strong password for your account
                </p>
                
                <div style={{ marginBottom: '20px' }}>
                  <label style={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.9)',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}>
                    New Password
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showNewPassword ? "text" : "password"}
                      value={forgotPasswordData.newPassword}
                      onChange={(e) => setForgotPasswordData({
                        ...forgotPasswordData,
                        newPassword: e.target.value
                      })}
                      placeholder="Enter new password"
                      style={{
                        width: '100%',
                        padding: '14px 45px 14px 16px',
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '14px',
                        transition: 'all 0.3s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                      autoFocus
                      disabled={isResettingPassword}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        color: 'rgba(255, 255, 255, 0.5)',
                        cursor: 'pointer',
                        fontSize: '16px',
                        transition: 'color 0.3s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
                      onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.5)'}
                      disabled={isResettingPassword}
                    >
                      <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>
                
                <div style={{ marginBottom: '30px' }}>
                  <label style={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.9)',
                    marginBottom: '8px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}>
                    Confirm New Password
                  </label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={forgotPasswordData.confirmPassword}
                      onChange={(e) => setForgotPasswordData({
                        ...forgotPasswordData,
                        confirmPassword: e.target.value
                      })}
                      placeholder="Confirm new password"
                      style={{
                        width: '100%',
                        padding: '14px 45px 14px 16px',
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '14px',
                        transition: 'all 0.3s'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                      disabled={isResettingPassword}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        color: 'rgba(255, 255, 255, 0.5)',
                        cursor: 'pointer',
                        fontSize: '16px',
                        transition: 'color 0.3s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
                      onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.5)'}
                      disabled={isResettingPassword}
                    >
                      <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                    </button>
                  </div>
                  {forgotPasswordData.confirmPassword && 
                   forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword && (
                    <p style={{
                      color: '#ef4444',
                      fontSize: '12px',
                      marginTop: '5px'
                    }}>
                      Passwords do not match
                    </p>
                  )}
                </div>
                
                <button
                  type="submit"
                  disabled={isResettingPassword || 
                           !forgotPasswordData.newPassword || 
                           !forgotPasswordData.confirmPassword ||
                           forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword}
                  style={{
                    width: '100%',
                    padding: '16px',
                    backgroundColor: (isResettingPassword || 
                                     !forgotPasswordData.newPassword || 
                                     !forgotPasswordData.confirmPassword ||
                                     forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) 
                                     ? 'rgba(79, 70, 229, 0.5)' : '#4f46e5',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: (isResettingPassword || 
                             !forgotPasswordData.newPassword || 
                             !forgotPasswordData.confirmPassword ||
                             forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) 
                             ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    position: 'relative'
                  }}
                  onMouseEnter={(e) => {
                    if (!isResettingPassword && 
                        forgotPasswordData.newPassword && 
                        forgotPasswordData.confirmPassword &&
                        forgotPasswordData.newPassword === forgotPasswordData.confirmPassword) {
                      e.currentTarget.style.backgroundColor = '#4338ca';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isResettingPassword && 
                        forgotPasswordData.newPassword && 
                        forgotPasswordData.confirmPassword &&
                        forgotPasswordData.newPassword === forgotPasswordData.confirmPassword) {
                      e.currentTarget.style.backgroundColor = '#4f46e5';
                    }
                  }}
                >
                  {isResettingPassword ? (
                    <>
                      <span>Resetting...</span>
                      <div style={{
                        display: 'inline-block',
                        marginLeft: '10px',
                        width: '16px',
                        height: '16px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        verticalAlign: 'middle'
                      }} />
                    </>
                  ) : 'Reset Password'}
                </button>
              </form>
            )}
            
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        </div>
      )}

      {/* Back To Top - Start */}
      <div className="backtotop">
        <a href="#" className="scroll">
          <i className="fa-solid fa-arrow-up"></i>
        </a>
      </div>
      {/* Back To Top - End */}

      {/* Site Header - Start */}
      <header className="site_header">
        <div className="nav_wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-5 d-flex align-items-center">
                <div className="site_logo">
                  <a className="site_link" href="/">
                    <img loading="lazy" src={logo} alt="Logo" />
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-2">
                <nav className="main_menu navbar-box navbar-expand-lg">
                  <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
                    <ul className="main_menu_list unordered_list text-uppercase">
                      <li className="active">
                        <a className="nav-link" href="/">
                          <span className="nav_link_label" data-text="Home">Home</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#about">
                          <span className="nav_link_label" data-text="About Us">About Us</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#services">
                          <span className="nav_link_label" data-text="Services">Services</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#metamask">
                          <span className="nav_link_label" data-text="Metamask">Metamask</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="#contact">
                          <span className="nav_link_label" data-text="Contact Us">Contact Us</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="col-lg-3 col-5">
                <ul className="btns_group unordered_list p-0 justify-content-end">
                  <li className="d-lg-none">
                    <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                      <i className="far fa-bars"></i>
                    </button>
                  </li>
                  <li>
                    <a className="ico_btn_outline" href="/register">
                      <span className="btn_icon">
                        <i className="fa-solid fa-user-plus"></i>
                      </span>
                      <span className="btn_label">Register</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Site Header - End */}

      <main className="page_content">
        <section className="register_section section_decoration">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5 position-relative">
                <form className="register_form" onSubmit={handleSubmit}>
                  <h1 className="heading_text text-center">Login to Willow Quantum</h1>
                  <p className="text-center">Enter your details to access your account</p>

                  {/* Login ID Input Field */}
                  <div className="form-group">
                    <label className="input_title" htmlFor="input_login_id">
                      Login ID<sup>*</sup>
                    </label>
                    <input
                      id="input_login_id"
                      className={`form-control ${error ? 'is-invalid' : ''}`}
                      type="text"
                      name="login_id"
                      value={formData.login_id}
                      onChange={handleInputChange}
                      placeholder="Enter your email or account name"
                      required
                      disabled={isSubmitting}
                      autoComplete="off"
                    />
                  </div>

                  <div className="form-group">
                    <label className="input_title" htmlFor="input_password">
                      Password<sup>*</sup>
                    </label>
                    <div className="password-input-group" style={{ position: 'relative' }}>
                      <input
                        id="input_password"
                        className={`form-control ${error ? 'is-invalid' : ''}`}
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Enter your password"
                        required
                        disabled={isSubmitting}
                        style={{ paddingRight: '45px' }}
                        autoComplete="off"
                      />
                      <button
                        type="button"
                        className="password-toggle-btn"
                        onClick={togglePasswordVisibility}
                        disabled={isSubmitting}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          color: '#6c757d',
                          cursor: 'pointer',
                          padding: '5px',
                          zIndex: 2
                        }}
                      >
                        <FontAwesomeIcon 
                          icon={showPassword ? faEyeSlash : faEye} 
                          style={{ fontSize: '18px' }}
                        />
                      </button>
                    </div>
                    {error && (
                      <div className="invalid-feedback d-block">{error}</div>
                    )}
                  </div>

                  {/* Remember Me and Forgot Password */}
                  <div className="form-group">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            disabled={isSubmitting}
                            style={{border : "1px solid white"}}
                          />
                          <label className="form-check-label" htmlFor="rememberMe">
                            Remember me
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 text-end">
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={handleOpenForgotPasswordModal}
                          disabled={isSubmitting}
                          style={{ fontSize: '14px' }}
                        >
                          Forgot password?
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Invisible reCAPTCHA */}
                  <div ref={recaptchaRef} style={{ display: 'none' }} />

                  <div className="row">
                    <div className="col-md-12 text-center">
                      <p className="forget_pass mb-0">
                        New user? <a href="/register"><u>Register here</u></a>
                      </p>
                    </div>
                  </div>

                  <button
                    className="btn"
                    type="submit"
                    disabled={isSubmitting}
                    style={{ position: 'relative' }}
                  >
                    <span className="btn_label">
                      {isSubmitting ? 'Quantum...' : 'Login'}
                    </span>
                    <span className="btn_icon">
                      {isSubmitting ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <i className="fa-regular fa-arrow-up-right"></i>
                      )}
                    </span>
                  </button>
                </form>

                <div className="decoration_item shape_flower">
                  <img src={flowerShape} alt="Flower" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Site Footer - Start */}
      <footer className="ico_site_footer section_decoration section_shadow_top">
        <div className="decoration_item shape_top">
          <img src={footerShape} alt="Bottom Line Shape" />
        </div>
        <div className="container">
          <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
            <li>
              <a className="scrollspy_btn" href="#home">
                <span className="pagelist_label">Home</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#about">
                <span className="pagelist_label">About Us</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#services">
                <span className="pagelist_label">Services</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#metamask">
                <span className="pagelist_label">Metamask</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#team">
                <span className="pagelist_label">Team</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#contact">
                <span className="pagelist_label">Contact Us</span>
              </a>
            </li>
          </ul>
          <div className="middle_area">
            <div className="column">
              <h3 className="footer_title text-uppercase">Join our social group</h3>
              <ul className="social_block style_2 unordered_list justify-content-center">
                <li>
                  <a href="#!">
                    <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.1817 2.34636C10.5036 3.04236 7.14877 4.48456 2.11879 6.67146C1.30201 6.99576 0.873436 7.31296 0.834656 7.62286C0.768491 8.14806 1.42705 8.35476 2.32148 8.63456C2.44372 8.67336 2.57025 8.71206 2.69969 8.75516C3.58123 9.04066 4.76611 9.37506 5.38149 9.38796C5.9409 9.39946 6.56497 9.16986 7.25381 8.69916C11.9531 5.53206 14.379 3.93206 14.5314 3.89756C14.6393 3.87316 14.7888 3.84166 14.8894 3.93206C14.9901 4.02106 14.9801 4.19036 14.97 4.23626C14.9038 4.51326 12.3241 6.90826 10.9868 8.14806C10.5698 8.53416 10.2749 8.80826 10.2146 8.87136C10.0794 9.01056 9.94141 9.14396 9.80908 9.27176C8.98941 10.0581 8.37683 10.6494 9.84356 11.6137C10.5482 12.0772 11.1119 12.4604 11.6741 12.8421C12.2882 13.2597 12.9008 13.6758 13.6945 14.1953C13.8959 14.3273 14.0886 14.4636 14.2769 14.5971C14.9916 15.1065 15.6343 15.5628 16.4281 15.4911C16.8883 15.448 17.3656 15.0161 17.6072 13.726C18.1781 10.6752 19.3026 4.06836 19.5629 1.34476C19.5788 1.11856 19.5691 0.891358 19.5341 0.667358C19.5132 0.486458 19.425 0.320058 19.2868 0.201058C19.0812 0.0331581 18.7619 -0.002742 18.6182 0.000158001C17.9696 0.011558 16.9746 0.357458 12.1817 2.34636Z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.7876 14L9.31558 5.8405L9.32498 5.8482L14.2588 0H12.6101L8.59076 4.76L5.39902 0H1.07488L6.18362 7.6179L0.794922 14H2.44366L6.91214 8.7042L10.4635 14H14.7876ZM4.74576 1.2727L12.4234 12.7273H11.1168L3.43295 1.2727H4.74576Z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <i className="fa-brands fa-github" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Subscribe to our newsletter</h3>
              <form className="ico_newsletter_form" action="#">
                <input type="email" name="email" placeholder="Enter your email" />
                <button className="submit_btn" type="submit">Submit</button>
              </form>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
              <a className="ico_creative_btn" href="#!">
                <span className="btn_wrapper">
                  <span className="btn_icon_left">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                      <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                      <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                    </svg>
                  </span>
                  <span className="btn_label">Purchase a Token</span>
                  <span className="btn_icon_right">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                      <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                      <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                    </svg>
                  </span>
                </span>
              </a>
            </div>
          </div>
          <div className="footer_bottom text-center">
            <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Quantum. All rights reserved.</p>
          </div>
        </div>
      </footer>
      {/* Site Footer - End */}
    </div>
  );
};

export default SignIn;